import { DESTINATIONS } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

export default function Destinations() {
    return (
        <section id="destinations" className="scroll-mt-20 bg-navy-deep py-24 lg:py-32" data-testid="destinations-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 07 &mdash; Healthcare Destinations</ChapterTag>
                <SectionHead
                    className="mt-8"
                    eyebrow="Healthcare & Medical Tourism"
                    title="International Healthcare Connections Across Asia"
                />

                <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
                    {DESTINATIONS.map((d, i) => (
                        <FadeUp key={d.id} delay={i * 0.08} className="h-full">
                            <article
                                data-testid={`destination-card-${d.id}`}
                                className="group relative flex h-[380px] flex-col justify-end overflow-hidden border border-white/8"
                            >
                                <img
                                    src={d.image}
                                    alt={d.imageAlt}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-[1.07]"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/45 to-navy-deep/10" aria-hidden="true" />
                                <span className="absolute left-6 top-5 text-[11px] font-semibold uppercase tracking-[0.3em] text-gold" aria-hidden="true">
                                    0{i + 1}
                                </span>
                                <div className="relative p-6">
                                    <h3 className="font-serif text-3xl font-light text-ivory">{d.name}</h3>
                                    <p className="mt-3 text-[13px] leading-relaxed text-slate-200/85">{d.copy}</p>
                                </div>
                                <span className="absolute bottom-0 left-0 h-[2px] w-full origin-left scale-x-0 bg-gold transition-transform duration-700 group-hover:scale-x-100" aria-hidden="true" />
                            </article>
                        </FadeUp>
                    ))}
                </div>

                <FadeUp delay={0.15}>
                    <p className="mt-8 text-xs leading-relaxed tracking-wide text-slate-500">
                        Viet Medica Ltd is an independent healthcare and medical-tourism coordinator. We do not own hospitals and we do not provide medical treatment.
                    </p>
                </FadeUp>
            </div>
        </section>
    );
}
